<template>
  <div class="lianxiwomen">
    <!-- 头部 -->
    <!-- <Header /> -->
    <div class="tops">
      <img
        src="@/P09_BaiCaiHui/assets/images/lianxiwomen/banner.png"
        alt="百才汇"
      />
    </div>
    <div class="is01">
      <div class="biaoti">
        <img
          src="@/P09_BaiCaiHui/assets/images/lianxiwomen/biaoti-01.png"
          alt=""
        />
      </div>
      <ul class="lie" style="margin-bottom: 20px">
        <li style="margin-right: 20px">
          <img
            src="@/P09_BaiCaiHui/assets/images/lianxiwomen/kehu-01.png"
            alt="百才汇"
          />
        </li>
        <li>
          <img
            src="@/P09_BaiCaiHui/assets/images/lianxiwomen/kehu-02.png"
            alt="百才汇"
          />
        </li>
      </ul>
      <ul class="lie">
        <li style="margin-right: 20px">
          <img
            src="@/P09_BaiCaiHui/assets/images/lianxiwomen/kehu-03.png"
            alt="百才汇"
          />
        </li>
        <li>
          <img
            src="@/P09_BaiCaiHui/assets/images/lianxiwomen/kehu-04.png"
            alt="百才汇"
          />
        </li>
      </ul>
    </div>
    <div class="is02">
      <div class="biaotier">
        <img
          src="@/P09_BaiCaiHui/assets/images/lianxiwomen/biaoti-02.png"
          alt=""
        />
      </div>
      <div class="neirong">
        <img
          src="@/P09_BaiCaiHui/assets/images/lianxiwomen/guanyu.png"
          alt="百才汇"
        />
        <p>
          百才汇坐落于上海人才大厦22楼，人才大厦是上海人力资源产业的地标性建筑，也是办理上海落户的政府大楼。百才汇坐拥强势资源，致力于帮助每一位想在上海落户的人才，实现他们的上海梦乃至人生梦。
        </p>
        <p>协助您解决、定制落户方案，为您提供便捷、省心的落户指导与操作。</p>
        <p>
          通过严格把控业务办理风险，保障办理过程安全顺利、平稳进行，全程可监控、可追溯、业务进度实时跟进，为您提供高效的落户方案。
        </p>
      </div>
    </div>
    <div class="is03">
      <div class="biaoge">
        <div class="biaotier">
          <img
            src="@/P09_BaiCaiHui/assets/images/lianxiwomen/biaoti-03.png"
            alt=""
          />
        </div>
      </div>
      <div class="di">
        <ul>
          <li class="li1">
            <p class="p1">扫码添加</p>
            <p class="p2">扫码关注官方微信公众号：上海落户通</p>
            <p class="p2">首次关注送大礼</p>
            <p class="p2">免费落户咨询&评估优惠券一张</p>
            <p class="p2">落户费用抵用券一张 (价值5000元)</p>
          </li>
          <li class="li2">
            <img src="../../../assets/images/lianxiwomen/erweima.png" alt="" />
          </li>
        </ul>
      </div>
      <div class="biaodan">
        <div class="inpis">
          <!-- <el-input class="inp" placeholder="您的姓名"></el-input> -->
          <div class="isShuru">
            <input
              class="inp"
              v-model="username"
              type="text"
              placeholder="您的姓名"
            />
            <input
              class="inp"
              v-model="tel"
              type="text"
              placeholder="联系方式"
            />
            <!-- <input class="liuyan" type="textarea" placeholder="联系方式" /> -->
            <el-input
              type="textarea"
              class="liuyan"
              v-model="textarea"
              placeholder="留言"
            >
            </el-input>
            <button class="btn" @click="registerOne">提交</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Bottom />
  </div>
</template>

<script>
import Vue from "vue";
import { Notify } from "vant";
import Header from "@/P09_BaiCaiHui/components/Header.vue";
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
export default {
  components: {
    Header,
    Bottom,
  },
  metaInfo() {
    return {
      title: "落户联系方式_百才汇联系方式-百才汇",
      meta: [
        {
          name: "keywords",
          content: "落户联系方式,百才汇联系方式",
        },
        {
          name: "description",
          content:
            "百才汇是专业的落户团队，拥有大量的成功案例，落户联系方式：400-800-8772！",
        },
      ],
    };
  },
  data() {
    return {
      textarea: "",
      username: "",
      tel: "",
    };
  },
  methods: {
    registerOne() {
      if (!this.username) {
        Notify({ type: "danger", message: "请输入您的姓名" });
        this.username = "";
        return false;
      }
      if (!this.tel) {
        Notify({ type: "danger", message: "请输入正确手机号码" });
        this.tel = "";
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: this.username, //姓名
          C01_Tel: this.tel, //联系方式
          C01_Message: this.liuyan, // 留言
          C01_Origin: 193, //信息来源
        })
        .then((res) => {
          if (res.data.Message == "success") {
            this.$message.success("报名成功!");
            this.username = "";
            this.tel = "";
            this.liuyan = "";
          } else if (res.data.Code == 400) {
            Notify({ type: "success", message: res.data.Message });
          } else {
            Notify({ type: "success", message: res.data.Message });
          }
        });
    },
  },
};
</script>

<style lang="scss" scope>
.lianxiwomen {
  .tops {
    margin-top: 80px;
    width: 100%;
    height: 250px;
    img {
      width: 100%;
      height: 250px;
    }
  }
  .is01 {
    padding: 54px 0px;
    box-sizing: border-box;
    // background: #f7f7f7;
    background: #fff;
    .biaoti {
      width: 542px;
      height: 61px;
      margin: auto;
      margin-bottom: 30px;
      img {
        width: 542px;
        height: 61px;
      }
    }
    .lie {
      width: 680px;
      margin: auto;
      display: flex;
      li {
        width: 330px;
        height: 315px;
        img {
          width: 100%;
          height: 315px;
        }
      }
    }
  }
  .is02 {
    background: #f7f7f7;
    padding: 60px 0px;
    box-sizing: border-box;
    .biaotier {
      width: 122px;
      height: 56px;
      margin: auto;
      margin-bottom: 47px;
      img {
        width: 122px;
        height: 56px;
      }
    }
    .neirong {
      width: 670px;
      height: 696px;
      margin: auto;
      background: #ffffff;
      border-radius: 10px;
      img {
        width: 100%;
        height: 255px;
      }
      p {
        padding: 0px 40px;
        box-sizing: border-box;
        margin-top: 24px;
        letter-spacing: 1px;
        font-size: 22px;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
      }
    }
  }
  .is03 {
    position: relative;
    .biaoge {
      padding-top: 56px;
      height: 400px;
      .biaotier {
        width: 122px;
        height: 56px;
        margin: auto;
        margin-bottom: 47px;
        img {
          width: 122px;
          height: 56px;
        }
      }
    }
    .di {
      background: url("../../../assets/images/lianxiwomen/beijing.png")
        no-repeat center/cover;
      height: 494px;
      width: 100%;
      ul {
        width: 570px;
        margin: auto;
        padding-top: 260px;
        box-sizing: border-box;
        display: flex;
        .li1 {
          .p1 {
            font-size: 22px;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 25px;
          }
          .p2 {
            font-size: 20px;
            font-weight: 400;
            color: #ffffff;
            line-height: 31px;
          }
        }
        .li2 {
          margin-left: 82px;
          img {
            width: 128px;
            height: 128px;
            margin-top: 56px;
          }
        }
      }
    }
    .biaodan {
      width: 100%;
      position: absolute;
      top: 158px;
      .inpis {
        width: 570px;
        height: 464px;
        background: #ffffff;
        box-shadow: 0px 1px 13px 0px rgba(170, 135, 86, 0.22);
        border-radius: 20px;
        margin: auto;
        padding-top: 42px;
        box-sizing: border-box;
        .isShuru {
          width: 351px;
          margin: auto;
          .inp {
            width: 351px;
            height: 50px;
            background: #ffffff;
            border: 1px solid #acacac;
            border-radius: 25px;
            padding-left: 24px;
            background: url("../../../assets/images/red.png") no-repeat 10px;
            background-size: 4% 25%;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: 400;
            color: #666666;
          }
          .liuyan {
            width: 351px;
            height: 150px;
            background: #ffffff;
            // border: 1px solid #acacac;
            border-radius: 25px;
            line-height: 20px;
            margin-bottom: 40px;
            .el-textarea__inner {
              letter-spacing: 1px;
              width: 351px;
              height: 150px;
              background: #ffffff;
              border: 1px solid #acacac;
              border-radius: 25px;
              line-height: 20px;
              font-size: 20px;
              font-weight: 400;
              color: #666666;
            }
          }
          ::-webkit-input-placeholder {
            color: #666666;
          }
          .btn {
            width: 216px;
            height: 50px;
            background: #e3af66;
            border-radius: 25px;
            cursor: pointer; //手指
            font-size: 22px;
            font-weight: 400;
            color: #ffffff;
            display: block;
            margin: auto;
          }
          button:focus {
            outline: 0;
          }
        }
      }
    }
  }
}
</style>